import { render, staticRenderFns } from "./BookEntityDetails.vue?vue&type=template&id=980aa514&scoped=true"
import script from "./BookEntityDetails.vue?vue&type=script&lang=js"
export * from "./BookEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./BookEntityDetails.vue?vue&type=style&index=0&id=980aa514&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980aa514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('980aa514')) {
      api.createRecord('980aa514', component.options)
    } else {
      api.reload('980aa514', component.options)
    }
    module.hot.accept("./BookEntityDetails.vue?vue&type=template&id=980aa514&scoped=true", function () {
      api.rerender('980aa514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BookEntityDetails.vue"
export default component.exports